/* @flow */

import React from "react";
import { useTranslate } from "@awardit/react-use-translate";
import MainLogo from "icons/logo.svg";

import styles from "./styles.scss";

type Props = {
  className?: string,
};

const Logo = ({ className, ...props }: Props): React$Node => {
  const t = useTranslate();

  return (
    <div {...props} className={className}>
      <MainLogo
        alt={t("LOGO.ALT")}
        aria-label={t("LOGO.TITLE")}
        className={styles.logoMain}
      />
    </div>
  );
};

export default Logo;
